import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import api from "../utils/base_url";
import toast from "react-hot-toast";
import "../styles/PasswordReset.css"; /* ← shared file */

const PasswordResetConfirm = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const validatePassword = (p) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(p);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password || !confirmPassword) return toast.error("Please fill all fields.");
    if (password !== confirmPassword)  return toast.error("Passwords do not match.");
    if (!validatePassword(password))   return toast.error(
      "Min 8 chars with uppercase, lowercase, number & special character."
    );

    setLoading(true);
    try {
      const res = await api.post("set-password/", { uid, token, password });
      if (res.data.status === true) {
        toast.success("Password reset successful! Please login.");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error(res.data.message || "Password reset failed.");
      }
    } catch {
      toast.error("Invalid or expired link. Please request a new one.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pr-wrapper">
      <motion.div
        className="pr-card"
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.55, ease: [0.4, 0, 0.2, 1] }}
      >
        {/* Icon */}
        <div className="pr-icon-wrap">
          <FaLock />
        </div>

        <p className="pr-title">Set New Password</p>
        <p className="pr-subtitle">
          Choose a strong password to keep your account secure.
        </p>

        <form onSubmit={handleSubmit} className="pr-form" noValidate>
          {/* New password */}
          <div className="pr-field">
            <span className="pr-field-icon"><FaLock /></span>
            <input
              className="pr-field-input"
              type={showPassword ? "text" : "password"}
              placeholder=" "
              value={password}
              required
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <label className="pr-field-label">New password</label>
            <button
              type="button"
              className="pr-toggle"
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword(v => !v)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Confirm password */}
          <div className="pr-field">
            <span className="pr-field-icon"><FaLock /></span>
            <input
              className="pr-field-input"
              type={showConfirm ? "text" : "password"}
              placeholder=" "
              value={confirmPassword}
              required
              autoComplete="new-password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <label className="pr-field-label">Confirm password</label>
            <button
              type="button"
              className="pr-toggle"
              aria-label={showConfirm ? "Hide password" : "Show password"}
              onClick={() => setShowConfirm(v => !v)}
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Strength hint */}
          <p className="pr-hint">
            Min. 8 characters · uppercase · lowercase · number · special character
          </p>

          <button type="submit" className="pr-btn" disabled={loading}>
            {loading && <span className="pr-spinner" aria-hidden />}
            {loading ? "Resetting…" : "Reset password"}
          </button>
        </form>

        <hr className="pr-divider" />

        <div className="pr-back">
          <Link to="/login" className="pr-back-link">← Back to Login</Link>
        </div>
      </motion.div>
    </div>
  );
};

export default PasswordResetConfirm;